import HttpClientToken from '../../services/HttpClientToken';
import HttpClientFileToken from '../../services/HttpClientFileToken';

import { ConsultaTramitesRecibidosParams, ConsultaTramitesRecibidosResponse, defaultConsultaTramitesRecibidos, DescargarTramitesRecibidosParams } from '../../interfaces/comun/RecepcionInterface';

export const ConsultaTramitesRecibidos = ( params: ConsultaTramitesRecibidosParams ) => {

    return new Promise<ConsultaTramitesRecibidosResponse>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/Recepcion/ConsultaTramitesRecibidos', params, token)
            .then( ({ data } : { data : ConsultaTramitesRecibidosResponse } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( { ...defaultConsultaTramitesRecibidos } );
            });

        }

    });

}

export const DescargarTramitesRecibidos = ( params: DescargarTramitesRecibidosParams ) => {

    return new Promise<Blob | null>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientFileToken.post('/Api/Recepcion/DescargarTramitesRecibidos/', params, token)
            .then( ({ data } : { data : Blob } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( null );
            });

        }

    });

}
